import React from 'react';
import styled from 'styled-components';

import { devices } from 'styles/devices';
import { colors } from 'styles/colors';

const Footer = () => (
   <Wrapper>
      <Copyright>&copy; Konsport</Copyright>
      <Address>
         <AddressItem>Jana Kilińskiego 75</AddressItem>
         <AddressItem>95-083 Kazimierz</AddressItem>
         <AddressItem>+48 43 677 50 63</AddressItem>
         <AddressItem>biuro@konsport.com.pl</AddressItem>
      </Address>
   </Wrapper>
);

const Wrapper = styled.footer`
   display: flex;
   justify-content: space-between;
   align-items: flex-end;
   padding: 20px;
   width: 100%;
   margin: 0 auto;
   color: ${colors.neutral50};
   font-size: 10px;

   ${devices.tabletL} {
      padding: 20px 60px;
   }

   ${devices.tabletXL} {
      padding: 20px 100px;
   }

   ${devices.desktop} {
      padding: 40px 100px;
      font-size: 12px;
   }

   ${devices.desktopFHD} {
      padding: 40px 100px;
   }
`;

const Address = styled.address`
   padding: 0;
   margin: 0;
   font-size: inherit;

   ${devices.mobileL} {
      display: flex;
   }
`;

const Copyright = styled.span`
   display: block;
`;

const AddressItem = styled.span`
   display: block;
   padding: 0 10px;
   margin-right: -10px;
   font-size: inherit;

   ${devices.tabletXL} {
      padding: 0 20px;
      margin-right: -20px;
   }

   ${devices.desktopHD} {
      padding: 0 40px;
      margin-right: -40px;
   }
`;

export default Footer;
